<!--坏件库-扫码处理：扫销售单号查出未处理坏件入库单，字段与待处理"处理"页面一致，坏件单/销售单可点开，处理控件右上角固定-->
<template>
  <el-dialog title="坏件扫码处理" :visible.sync="dialogFormVisible" custom-class="full-dialog" center :close-on-click-modal="false" append-to-body>
    <!--顶行固定：左=扫码框(自动聚焦)，右=处理方式控件-->
    <div class="bsh-topbar">
      <div class="bsh-left">
        <el-select v-model="scanCangku" size="small" placeholder="仓库（必选）" class="bsh-cangku-sel" filterable @change="onScanCangkuChange">
          <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
        </el-select>
        <el-input v-model="scanSaleOrder" ref="scanInput" size="small" class="bsh-scan-input" placeholder="请扫销售单号（回车查询）"
                  @keyup.enter.native="scanSearch" @clear="clearScan" clearable>
          <el-button slot="append" icon="el-icon-search" @click="scanSearch"></el-button>
        </el-input>
        <span>共 <b>{{tableData.length}}</b> 行</span>
        <span style="padding-left: 15px">数量：<b>{{totalQty}}</b></span>
        <span style="padding-left: 15px">处理：<b>{{totalHandleQty}}</b></span>
      </div>
      <div class="bsh-right" v-if="tableData.length>0">
        <el-select v-if="handleMode==10" v-model="targetCangku" size="small" placeholder="入库仓库" style="width: 130px;margin-left: 6px;" @change="onTargetCangkuChange">
          <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
        </el-select>
        <el-select v-if="handleMode==10 && warehouseArr.length>1" v-model="warehouse" size="small" placeholder="库位" style="width: 100px;margin-left: 6px;" @change="onWarehouseChange">
          <el-option v-for="item in warehouseArr" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
        </el-select>
        <el-select v-if="handleMode==30" v-model="moveCangku" size="small" placeholder="转入仓库" style="width: 130px;margin-left: 6px;" @change="onMoveCangkuChange">
          <el-option v-for="item in cangkuMoveList" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
        </el-select>
        <el-select v-if="handleMode==30 && moveWarehouseArr.length>1" v-model="moveWarehouse" size="small" placeholder="库位" style="width: 100px;margin-left: 6px;" @change="onMoveWarehouseChange">
          <el-option v-for="item in moveWarehouseArr" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
        </el-select>
        <el-input v-if="handleMode==20" v-model="supplier" size="small" style="width: 120px;margin-left: 6px;" placeholder="选择供应商"
                  @click.native="changepcustomer" readonly></el-input>
        <el-input v-model="remark" size="small" class="bsh-remark" placeholder="备注" style="min-width: 180px;"></el-input>
        <el-input v-if="handleMode==20" v-model="logisticsNum" size="small" style="width: 110px;margin-left: 6px;" placeholder="快递单号"></el-input>
        <el-select v-model="handleMode" size="small" placeholder="处理方式" style="width: 120px;" @change="onHandleModeChange">
        <el-option v-for="item in brokenpartsType" :key="item.value" :label="item.name" :value="item.value"></el-option>
       </el-select>
        <el-button type="primary" size="small" class="bsh-save" :disabled="tableData.length==0||saving" @click="saveHandle" :loading="saving">确认处理</el-button>
        <el-button size="small" @click="dialogFormVisible=false">关 闭</el-button>
      </div>
    </div>

    <!--明细表格：字段与待处理"处理"页面(StorageBadEdit)一致，无已处理数量列；追加式扫码-->
    <div class="bsh-list">
      <el-table :data="tableData" size="mini" border class="bsh-table" height="100%" style="width: 100%;">
        <el-table-column prop="erpserial" label="坏件入库单号" width="130" align="center" fixed="left">
          <template slot-scope="scope">
            <span @click="lookBaosundan(scope.row)" style="cursor:pointer;font-weight:bold;">{{scope.row.erpserial}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ordernum" label="销售单号" width="130" align="center" fixed="left">
          <template slot-scope="scope">
            <span @click="lookDingdan(scope.row)" style="cursor:pointer;font-weight:bold;">{{scope.row.ordernum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="buyordernum" label="采购单号" width="120" align="center"></el-table-column>
        <el-table-column prop="seedname" label="名称" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="seedcode" label="编码" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="球镜" width="80" align="center">
          <template slot-scope="scope"><span style="white-space:nowrap;">{{getSphere(scope.row)}}</span></template>
        </el-table-column>
        <el-table-column label="柱镜" width="80" align="center">
          <template slot-scope="scope"><span style="white-space:nowrap;">{{getCylinder(scope.row)}}</span></template>
        </el-table-column>
        <el-table-column label="型号" width="90" align="center">
          <template slot-scope="scope"><span style="white-space:nowrap;">{{getModel(scope.row)}}</span></template>
        </el-table-column>
        <el-table-column label="色号" width="80" align="center">
          <template slot-scope="scope"><span style="white-space:nowrap;">{{getColor(scope.row)}}</span></template>
        </el-table-column>
        <el-table-column prop="customername" label="责任人" width="90">
          <template slot-scope="scope">
            <span style="white-space:nowrap;">{{scope.row.customername}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ordername" label="类别" width="90"></el-table-column>
        <el-table-column prop="remark" label="原因" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="accdate" label="入库日期" width="140" align="center"></el-table-column>
        <el-table-column prop="cangkuname" label="仓库" width="100"></el-table-column>
        <el-table-column prop="uname" label="录入人" width="90" align="center"></el-table-column>
        <el-table-column label="数量" width="70" align="center">
          <template slot-scope="scope">{{(parseInt(scope.row.totalnumber)||0)-(parseInt(scope.row.handlenumber)||0)}}</template>
        </el-table-column>
        <el-table-column label="处理数量" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.needhandlenumber" style="width: 90px;" @input="checkNum(scope.row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--查看销售单/坏件入库单-->
    <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    <CstagreementEdit ref="DataContactEdit" @bindGrid="reload"></CstagreementEdit>
    <!--供应商选择（按商品匹配）-->
    <ExternaldeptChaiDanSel ref="zhuandan" :unitgroup="3" @select="selectpcustomer" :title="'选择供应商'"></ExternaldeptChaiDanSel>
    <!--坏件出库单（处理成功后弹出）-->
    <StorageBadOut ref="StorageBadOut"></StorageBadOut>
  </el-dialog>
</template>

<script>
  import {badpartslist} from '@/api/set/warehouse';
  import {updateBrokenparks} from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel';
  import StorageBadOut from './StorageBadOut';

  export default {
    name: 'BadScanHandle',
    data() {
      return {
        dialogFormVisible: false,
        scanSaleOrder: '',
        scanCangku: '',//扫码仓库(必选，限定查询范围)
        tableData: [],
        handleMode: '',//处理方式
        brokenpartsType: [
          {value: 5, name: '损耗'},
          {value: 10, name: '入正式库'},
          {value: 20, name: '退回供应商'},
          {value: 30, name: '转其他仓库'}
        ],
        targetCangku: '',//入正式库仓库
        warehouseArr: [],//库位列表(row.warehouse JSON解析)
        warehouse: '',//库位serial
        warehousename: '',//库位名称
        moveCangku: '',//转入仓库
        moveWarehouseArr: [],//转入仓库库位列表
        moveWarehouse: '',//转入库位serial
        moveWarehousename: '',//转入库位名称
        supplier: '',//供应商
        supplierCode: '',//供应商编码
        remark: '',
        logisticsNum: '',
        jxcstoreData: [],//仓库列表
        saving: false
      };
    },
    computed: {
      remainNum() {
        var n = 0;
        for (let i in this.tableData) {
          n += parseInt(this.tableData[i].needhandlenumber || 0);
        }
        return n;
      },
      cangkuMoveList() {
        //转仓列表：除入库仓库外的全部（简化：全部仓库）
        return this.jxcstoreData;
      },
      //数量合计（余量）
      totalQty() {
        var n = 0;
        for (let i in this.tableData) {
          n += (parseInt(this.tableData[i].totalnumber) || 0) - (parseInt(this.tableData[i].handlenumber) || 0);
        }
        return n;
      },
      //处理数量合计
      totalHandleQty() {
        var n = 0;
        for (let i in this.tableData) {
          n += parseInt(this.tableData[i].needhandlenumber) || 0;
        }
        return n;
      }
    },
    methods: {
      //对外入口
      show(scanCangku) {
        this.dialogFormVisible = true;
        this.scanSaleOrder = '';
        //仓库从列表页传入；传了用之，没传默认第一个（loadCangku回调处理），不允许清空
        if (scanCangku != null && scanCangku !== '') {
          this.scanCangku = scanCangku;
        } else if (!this.scanCangku) {
          this.scanCangku = this.jxcstoreData.length > 0 ? this.jxcstoreData[0].cangkucode : '';
        }
        this.tableData = [];
        this.handleMode = '';
        this.targetCangku = '';
        this.moveCangku = '';
        this.moveWarehouseArr = [];
        this.moveWarehouse = '';
        this.moveWarehousename = '';
        this.supplier = '';
        this.supplierCode = '';
        this.remark = '';
        this.logisticsNum = '';
        this.loadCangku();
        this.$nextTick(() => {
          if (this.$refs.scanInput) this.$refs.scanInput.focus();
        });
      },
      loadCangku() {
        //仓库已加载则直接补默认（如未传参）
        if (this.jxcstoreData.length > 0) {
          if (!this.scanCangku) this.scanCangku = this.jxcstoreData[0].cangkucode;
          return;
        }
        //对齐原版StorageBadEdit：cusandptbyind()无参，返回全部仓库（含仓位warehouse）
        var self = this;
        cusandptbyind().then(response => {
          if (response.data.code == 0 && response.data.obj) {
            self.jxcstoreData = response.data.obj;
            //未传参时默认第一个仓库
            if (!self.scanCangku && self.jxcstoreData.length > 0) {
              self.scanCangku = self.jxcstoreData[0].cangkucode;
            }
          }
        });
      },
      //扫销售单号查询未处理坏件（只按销售单号ordernum精确匹配；追加到表格不覆盖）
      scanSearch() {
        var saleOrder = (this.scanSaleOrder || '').trim();
        if (!this.scanCangku) {
          this.$message({type: 'warning', message: '请先选择仓库'});
          return;
        }
        if (!saleOrder) {
          this.$message({type: 'warning', message: '请先扫描销售单号'});
          return;
        }
        if (saleOrder.length < 8) {//单号太短提示
          this.$message({type: 'warning', message: '单号格式不正确'});
          return;
        }
        badpartslist({
          formtype: 78,
          status: 20,
          ordernum: saleOrder,//只按销售单号精确匹配(ordernum=#{ordernum})
          cangkucode: this.scanCangku//限定仓库(and d.CangKuCode=#{cangkucode})
        }).then(response => {
          var rows = (response.data && response.data.obj) ? response.data.obj : [];
          var existCount = 0, addCount = 0;
          for (let i in rows) {
            var row = rows[i];
            //处理数量自动填：未处理数 = 总数 - 已处理
            row.needhandlenumber = (parseInt(row.totalnumber) || 0) - (parseInt(row.handlenumber) || 0);
            if (row.needhandlenumber < 0) row.needhandlenumber = 0;
            //追加去重：按坏件入库单号unitguid去重
            var exist = false;
            for (let j in this.tableData) {
              if (this.tableData[j].unitguid == row.unitguid) { exist = true; break; }
            }
            if (exist) {
              existCount++;
            } else {
              this.tableData.push(row);
              addCount++;
            }
          }
          if (addCount == 0 && existCount > 0) {
            this.$message({type: 'warning', message: '该销售单的坏件已在列表中（' + existCount + ' 条重复跳过）'});
          } else if (addCount == 0 && rows.length == 0) {
            this.$message({type: 'warning', message: '未找到该销售单对应的未处理坏件入库单'});
          } else {
            this.$message({type: 'success', message: '新增 ' + addCount + ' 条' + (existCount > 0 ? '，跳过重复 ' + existCount + ' 条' : '')});
          }
          this.scanSaleOrder = '';
          this.$nextTick(() => {
            if (this.$refs.scanInput) this.$refs.scanInput.focus();
          });
        }).catch(() => {
          this.$message({type: 'error', message: '查询失败'});
        });
      },
      clearScan() {
        this.scanSaleOrder = '';
      },
      //切换仓库：清空已扫列表（防跨仓库混合）
      onScanCangkuChange() {
        if (this.tableData.length > 0) {
          this.tableData = [];
          this.handleMode = '';
          this.remark = '';
          this.logisticsNum = '';
        }
        this.$nextTick(() => {
          if (this.$refs.scanInput) this.$refs.scanInput.focus();
        });
      },
      //切换处理方式：清空相关字段
      onHandleModeChange() {
        this.targetCangku = '';
        this.warehouseArr = [];
        this.warehouse = '';
        this.warehousename = '';
        this.moveCangku = '';
        this.moveWarehouseArr = [];
        this.moveWarehouse = '';
        this.moveWarehousename = '';
        this.supplier = '';
        this.supplierCode = '';
        this.logisticsNum = '';
      },
      //入库仓库选择：加载库位（对齐原版StorageBadEdit changename）
      onTargetCangkuChange(val) {
        this.warehouseArr = [];
        this.warehouse = '';
        this.warehousename = '';
        var ck = this.getCangku(val);
        if (ck && ck.warehouse) {
          try {
            var arr = JSON.parse(ck.warehouse);
            if (arr.length > 1) {
              this.warehouseArr = arr;
              this.warehouse = arr[0].serial;
              this.warehousename = arr[0].name;
            }
          } catch (e) {}
        }
      },
      //库位选择
      onWarehouseChange(val) {
        for (let i in this.warehouseArr) {
          if (this.warehouseArr[i].serial == val) {
            this.warehousename = this.warehouseArr[i].name;
            break;
          }
        }
      },
      //转入仓库选择：加载库位（有库位才显示）
      onMoveCangkuChange(val) {
        this.moveWarehouseArr = [];
        this.moveWarehouse = '';
        this.moveWarehousename = '';
        var ck = this.getCangku(val);
        if (ck && ck.warehouse) {
          try {
            var arr = JSON.parse(ck.warehouse);
            if (arr.length > 1) {
              this.moveWarehouseArr = arr;
              this.moveWarehouse = arr[0].serial;
              this.moveWarehousename = arr[0].name;
            }
          } catch (e) {}
        }
      },
      //转入库位选择
      onMoveWarehouseChange(val) {
        for (let i in this.moveWarehouseArr) {
          if (this.moveWarehouseArr[i].serial == val) {
            this.moveWarehousename = this.moveWarehouseArr[i].name;
            break;
          }
        }
      },
      //打开供应商选择（按列表中商品编码匹配，借鉴StorageBadEdit changepcustomer）
      changepcustomer() {
        var seedcodes = [];
        for (let i in this.tableData) {
          if (this.tableData[i].seedcode && seedcodes.indexOf(this.tableData[i].seedcode) == -1) {
            seedcodes.push(this.tableData[i].seedcode);
          }
        }
        this.$refs.zhuandan.initData(seedcodes);
        this.$refs.zhuandan.show();
      },
      //供应商选择回调（借鉴StorageBadEdit selectpcustomer：pcustomerserial, pcustomer）
      selectpcustomer(pcustomerserial, pcustomer) {
        this.supplierCode = pcustomerserial;
        this.supplier = pcustomer;
      },
      //数量校验：不能超过未处理数，不能小于0
      checkNum(row) {
        var remain = (parseInt(row.totalnumber) || 0) - (parseInt(row.handlenumber) || 0);
        var val = parseInt(row.needhandlenumber);
        if (isNaN(val) || val < 0) row.needhandlenumber = 0;
        else if (val > remain) row.needhandlenumber = remain;
      },
      getPackagesize(ps) {
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          var arr = [];
          if (o.Y != null && o.Y !== '') arr.push('球' + o.Y);
          if (o.X != null && o.X !== '') arr.push('柱' + o.X);
          if (o.M != null && o.M !== '') arr.push(o.M);
          if (o.C != null && o.C !== '') arr.push(o.C);
          return arr.join(' ');
        } catch (e) {
          return ps;
        }
      },
      //packagesize JSON: Y=球镜 X=柱镜 M=型号 C=色号
      getSphere(row) {
        return this.getPk(row, 'Y');
      },
      getCylinder(row) {
        return this.getPk(row, 'X');
      },
      getModel(row) {
        return this.getPk(row, 'M');
      },
      getColor(row) {
        return this.getPk(row, 'C');
      },
      getPk(row, key) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o[key] != null && o[key] !== '') ? o[key] : '';
        } catch (e) { return ''; }
      },
      //查看销售单（与待处理"处理"页面一致：CstagreementEdit）
      lookDingdan(item) {
        if (item['ordernum']) {
          var s = {erpserial: item['ordernum']};
          this.$refs.DataContactEdit.initData(s);
          this.$refs.DataContactEdit.show();
          this.$refs.DataContactEdit.yincangdayin('order');
        }
      },
      //查看坏件入库单（与待处理"处理"页面一致：BaoSunDetail）
      lookBaosundan(item) {
        this.$refs.BaoSunDetail.show(item.erpserial, false);
      },
      reload() {
        //销售单查看后如有改动，刷新当前列表
        if (this.scanSaleOrder) this.scanSearch();
      },
      //保存处理（复用现有后台 updatebadparts）
      saveHandle() {
        if (!this.handleMode) {
          this.$message({type: 'warning', message: '请选择处理方式'});
          return;
        }
        if (this.handleMode == 5 && !this.remark) {
          this.$message({type: 'warning', message: '损耗需填写损坏原因'});
          return;
        }
        if (this.handleMode == 10 && !this.targetCangku) {
          this.$message({type: 'warning', message: '请选择入库仓库'});
          return;
        }
        if (this.handleMode == 30 && !this.moveCangku) {
          this.$message({type: 'warning', message: '请选择转入仓库'});
          return;
        }
        if (this.handleMode == 20 && !this.supplier) {
          this.$message({type: 'warning', message: '请选择供应商'});
          return;
        }
        var brokenlist = [];
        var overQty = [];
        for (let i in this.tableData) {
          var row = this.tableData[i];
          var remain = (parseInt(row.totalnumber) || 0) - (parseInt(row.handlenumber) || 0);
          //防御：处理数量不能超过剩余量，超过则修正为剩余量
          var num = parseInt(row.needhandlenumber);
          if (isNaN(num) || num <= 0) continue;
          if (num > remain) {
            overQty.push(row.erpserial + '(' + row.seedname + ')');
            num = remain;
            row.needhandlenumber = remain;
          }
          if (num > 0) {
            brokenlist.push({unitguid: row.unitguid, needhandlenumber: num});
          }
        }
        if (overQty.length > 0) {
          this.$message({type: 'warning', message: '以下明细处理数量超过剩余量，已按剩余修正：' + overQty.join('、')});
        }
        if (brokenlist.length == 0) {
          this.$message({type: 'warning', message: '请填写处理数量'});
          return;
        }
        var handlemode = '';
        for (let i in this.brokenpartsType) {
          if (this.brokenpartsType[i].value == this.handleMode) {
            handlemode = this.brokenpartsType[i].name;
            break;
          }
        }
        this.saving = true;
        var params = {
          brokenlist: JSON.stringify(brokenlist),
          remark: this.remark || '',
          value: this.handleMode,
          handlemode: handlemode,
          logisticsnum: this.logisticsNum
        };
        //仓库参数：所有处理方式都传（后端updatebrokencangku 571行必须，否则NPE代码错误）
        //损耗/转仓/退回无仓库选择时，取明细行第一个的仓库
        var defCk = null;
        for (let i in this.tableData) {
          if (this.tableData[i].cangkucode) { defCk = this.tableData[i]; break; }
        }
        if (this.handleMode == 10) {
          var ck = this.getCangku(this.targetCangku);
          params.cangkucode = this.targetCangku;
          params.cangkuname = ck ? ck.cangkuname : (defCk ? defCk.cangkuname : '');
          //库位：由onTargetCangkuChange加载(onTargetCangkuChange解析row.warehouse JSON)
          params.warehouse = this.warehouse || '';
          params.warehousename = this.warehousename || '';
        } else {
          //value=5损耗 / 20退供应商 / 30转仓：后端出库单需要仓库，取明细行仓库
          params.cangkucode = defCk ? defCk.cangkucode : '';
          params.cangkuname = defCk ? defCk.cangkuname : '';
        }
        if (this.handleMode == 30) {
          var mc = this.getCangku(this.moveCangku);
          params.movecangkucode = this.moveCangku;
          //转仓库位：后端movebrokencangku无独立库位字段，拼入名称传递（如"总仓·A区"）
          params.movecangkuname = (mc ? mc.cangkuname : '') + (this.moveWarehousename ? '·' + this.moveWarehousename : '');
        }
        if (this.handleMode == 20) {
          params.pcustomer = this.supplier;
          params.pcustomerserial = this.supplierCode || this.supplier;
        }
        updateBrokenparks(params).then(response => {
          this.saving = false;
          if (response.data.code == 0) {
            this.$message({type: 'success', message: '处理成功'});
            this.$emit('bindGrid');
            //弹出坏件出库单（对齐StorageBadEdit 636行）
            if (response.data.erpserial && this.$refs.StorageBadOut) {
              this.$refs.StorageBadOut.show(response.data.erpserial);
            }
            this.tableData = [];
            this.handleMode = '';
            this.remark = '';
            this.logisticsNum = '';
            this.scanSaleOrder = '';
            this.$nextTick(() => {
              if (this.$refs.scanInput) this.$refs.scanInput.focus();
            });
          } else {
            this.$message({type: 'error', message: response.data.msg || '处理失败'});
          }
        }).catch(() => {
          this.saving = false;
          this.$message({type: 'error', message: '处理失败'});
        });
      },
      getCangku(code) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == code) return this.jxcstoreData[i];
        }
        return null;
      }
    },
    components: {
      BaoSunDetail,
      CstagreementEdit,
      ExternaldeptChaiDanSel,
      StorageBadOut
    }
  };
</script>

<style scoped>
  /*顶行固定：扫码框左+处理控件右，与批量处理风格一致*/
  .bsh-topbar {
    display: flex; align-items: center; justify-content: space-between;
    border: 1px solid #ebeef5; border-radius: 4px; padding: 8px 12px; background: #fafafa; margin-bottom: 8px;
    position: sticky; top: 0; z-index: 10;
  }
  .bsh-left { display: flex; align-items: center; }
  .bsh-scan-input { width: 280px; }
  .bsh-cangku-sel { width: 140px; margin-right: 6px; }
  .bsh-count { margin-left: 12px; color: #909399; font-size: 13px; }
  .bsh-right { display: flex; align-items: center; max-width: 68%; }
  .bsh-remark { width: 160px; margin-left: 6px; }
  .bsh-save { margin-left: 8px; }
  .bsh-list { border: 1px solid #ebeef5; border-radius: 4px; padding: 6px; background: #fbfdff; height: calc(96vh - 180px); overflow: hidden; display: flex; flex-direction: column; }
  .bsh-table { width: 100%; flex: 1; }
  .bsh-total { padding: 5px 10px; font-size: 13px; border-top: 1px solid #ebeef5; background: #f5f7fa; }
  .bsh-total span { margin-right: 20px; color: #606266; }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/BadScanHandle.vue